import { FragenVonAbschnittDisplayModel, InfotextDisplayModel } from '@/api/model-index';
import { FrageDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/frage-display-model';
import { AnfrageService } from '@/api/service-index';
import { PortalContextService } from '@/core/services/portal-context.service';
import { StammdatenService } from '@/core/services/stammdaten.service';
import { UnfinishedHttpMethodsService } from '@/core/services/unfinished-http-methods.service';
import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FragenResolver implements Resolve<FrageDisplayModel[] | null | undefined> {
  constructor(protected anfrageService: AnfrageService, protected portalContextService: PortalContextService, protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService, protected stammdatenService: StammdatenService) {
  }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<FrageDisplayModel[] | null | undefined> {
    let anfrageId: string = <string>route.params['id'];
    let abschnittId = route.params['abschnittid'];
    let reportId = route.params['reportid'];
    let gutachtenId: string | undefined;

    if (this.portalContextService.CurrentGutachten) {
      gutachtenId = this.portalContextService.CurrentGutachten.gutachtenId!;
      anfrageId = this.portalContextService.CurrentGutachten.anfrage!.id;
    }

    await this.unfinishedHttpMethodsService.waitByUrl(state.url);

    if(this.portalContextService.CurrentAnfrage && this.portalContextService.CurrentAnfrage.id == anfrageId && this.portalContextService.CurrentAnfrage.fragen) {
      let cachedFragen = null;

      if (reportId)
        cachedFragen = this.portalContextService.CurrentAnfrage.fragen.find(frage => frage.abschnittId == abschnittId && frage.reportId == reportId);
      else
        cachedFragen = this.portalContextService.CurrentAnfrage.fragen.find(frage => frage.abschnittId == abschnittId);

      if (cachedFragen)
        return of(cachedFragen.fragen).toPromise();
    }

    return this.anfrageService.apiAnfrageGetFragenByEntityAndAreaGet({ anfrageId, abschnittId, reportId, gutachtenId }).pipe(map(response => {
      if (response) {
        if(this.portalContextService.CurrentAnfrage?.id == anfrageId) {
          let responseCache = new FragenVonAbschnittDisplayModel();
          responseCache.abschnittId = abschnittId;
          responseCache.reportId = reportId;
          responseCache.fragen = response;
          if (!this.portalContextService.CurrentAnfrage.fragen)
            this.portalContextService.CurrentAnfrage.fragen = [];
          this.portalContextService.CurrentAnfrage.fragen.push(responseCache);
          this.addFragenInfotext(response);
        }
          
        if (this.portalContextService.CurrentAnfrage?.fragen) {
          if (reportId)
            return this.portalContextService.CurrentAnfrage.fragen.find(frage => frage.abschnittId == abschnittId && frage.reportId == reportId)?.fragen;
          else
            return this.portalContextService.CurrentAnfrage.fragen.find(frage => frage.abschnittId == abschnittId)?.fragen;
        }
      }

      return undefined;
    })).toPromise();
  }

  addFragenInfotext(fragen: FrageDisplayModel[]) {
    fragen.filter(frage => frage.infotext?.find(infotext => infotext.text && infotext.text.length > 0)).forEach(frage => {
      let infotext = new InfotextDisplayModel();
      infotext.schluessel = 'question' + frage.frageId;
      infotext.beschreibung = frage.infotext;

      this.stammdatenService.InfoTexte?.setValue(infotext.schluessel, infotext);
    })
  }
}
